/**
 * 도메인 관련 유틸리티 함수
 */

/**
 * 현재 도메인이 "준비 중" 모달을 표시해야 하는 도메인인지 확인
 * @returns app.wholsee.kr 도메인이면 true, 그 외는 false
 *
 * @example
 * ```typescript
 * if (isUnderConstructionDomain()) {
 *   // 준비 중 모달 표시
 * }
 * ```
 */
export function isUnderConstructionDomain(): boolean {
  // 🔴 비활성화됨 (2025-11-25)
  // 재활성화 방법: 아래 주석 해제하고 return false 제거
  return false;

  // SSR 환경에서는 window 객체가 없으므로 false 반환
  // if (typeof window === 'undefined') {
  //   return false;
  // }
  //
  // return window.location.hostname === 'app.wholsee.kr';
}

/**
 * 현재 도메인 정보 반환
 * @returns 현재 hostname 문자열
 */
export function getCurrentDomain(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.hostname;
}
